var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Manages tile displacement details in the external damage declaration, number of displaced tiles.
 * touches: external damage declaration flow, tile displacement questionnaire.
 * invariants: the selected tile count syncs with the TileDisplacementDamage entity through updateExternalDamage and remains subject to field validation.
 * inputs: TileDisplacementDamage entity, tile count choices, validation helpers inherited from ExternalDamageComponent.
 * outputs: updates tileCount, renders the translated question, choices and validation feedback.
 * see: ExternalDamageComponent, externalDamages constants
 */
import Component from 'vue-class-component';
import { UiCard } from '@claims-ia/design-system';
import { TILE_DISPLACEMENT_COUNT_CHOICES, TILE_DISPLACEMENT_TITLE, } from '@declaration/constants/externalDamages';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { ExternalDamageComponent } from '@declaration/components/externalDamage/ExternalDamageComponent';
let TileDisplacement = class TileDisplacement extends ExternalDamageComponent {
    get title() {
        return this.translateExternalDamageKey(TILE_DISPLACEMENT_TITLE);
    }
    get tileCountChoices() {
        return TILE_DISPLACEMENT_COUNT_CHOICES;
    }
    get tileCount() {
        var _a;
        return (_a = this.externalDamage.tileCount) !== null && _a !== void 0 ? _a : null;
    }
    set tileCount(tileCount) {
        this.updateExternalDamage({ tileCount });
    }
};
TileDisplacement = __decorate([
    Component({ components: { RadioPrimaryButton, UiCard } })
], TileDisplacement);
export default TileDisplacement;
